module.exports = __webpack_public_path__ + "static/media/wood_floor_exit.f99157df.png";